





































import { Component, Vue, Prop } from "vue-property-decorator";
import { Document, Room } from "@/types";
import VideoGridAlone from "@/components/room/VideoGridAlone.vue";
import VideoGridSinging from "@/components/room/VideoGridSinging.vue";
import VideoGridListening from "@/components/room/VideoGridListening.vue";
import VideoParticipants from "@/components/room/VideoParticipants.vue";

import * as twilio from "twilio-video";

@Component({
  components: {
    VideoGridAlone,
    VideoGridSinging,
    VideoGridListening,
    VideoParticipants,
  },
})
export default class VideoGrid extends Vue {
  @Prop({ required: true })
  songAudioOutput!: AudioNode;

  @Prop({ required: true })
  audioCtx!: AudioContext;

  @Prop({ required: true })
  roomDoc!: Document<Room>;

  @Prop({ required: true })
  myId!: string;

  @Prop({ required: true })
  remoteParticipants!: Record<string, twilio.RemoteParticipant>;

  @Prop({ required: true })
  localParticipant!: twilio.LocalParticipant;

  get currentSong() {
    return this.room.currentSong || this.room.onDeck;
  }

  get room() {
    return this.roomDoc.data;
  }
}
